import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Spinner } from '@easydent/shared-ui';
import { demoLogin } from '@/lib/api';
import { useAuthStore } from '@/stores/authStore';

/**
 * One-click entry to the demo sandbox. The demo supplier has existed since the portal shipped —
 * what was missing was any way to reach it without being handed a password.
 */
const DemoPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const setSession = useAuthStore((s) => s.setSession);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    demoLogin()
      .then((s) => { setSession(s.accessToken, s.name); navigate('/', { replace: true }); })
      .catch(() => setError(t('demo.unavailable', 'The demo is not available right now.')));
  }, [navigate, setSession]);

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      {error
        ? <Alert variant="error">{error}</Alert>
        : <div className="flex flex-col items-center gap-3 text-sm text-muted">
            <Spinner size="lg" />
            Opening the demo…
          </div>}
    </div>
  );
};

export default DemoPage;
